module.exports = __webpack_public_path__ + "static/img/sdaqgl_hwxmaqxj_two.2e76f1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdaqgl_hwxmaqxj_two.png
// module id = +wf2
// module chunks = 21